import axios from 'axios';

export const getLatestPortfolioMonitoringConfig = async (customerId) => {
  const response = await axios.get(
    `admin/customer/${customerId}/portfolio-monitoring-config/latest`
  );
  return response.data;
};

export const listPortfolioMonitoringConfigVersions = async (customerId) => {
  const response = await axios.get(
    `admin/customer/${customerId}/portfolio-monitoring-config/versions`
  );
  return response.data;
};

export const getPortfolioMonitoringConfigVersion = async (customerId, version) => {
  const response = await axios.get(
    `admin/customer/${customerId}/portfolio-monitoring-config/versions/${version}`
  );
  return response.data;
};

export const createPortfolioMonitoringConfigVersion = async (customerId, body) => {
  const response = await axios.post(
    `admin/customer/${customerId}/portfolio-monitoring-config`,
    body
  );
  return response.data;
};
